module.exports = __webpack_public_path__ + "static/media/cineonhub_change.fe6a15fd.svg";